import { tns } from '../../../node_modules/tiny-slider/src/tiny-slider';

(function () {
  tns({
    container: '.js-clients-slider',
    prevButton: '.js-clients-slider-prev',
    nextButton: '.js-clients-slider-next',
    mouseDrag: true,
    autoplay: true,
    autoplayButtonOutput: false,
    speed: 300,
    nav: false,
    items: 1,
    responsive: {
      768: {
        items: 3
      },
      1200: {
        items: 5
      }
    }
  });
})();

